module.exports = __webpack_public_path__ + "static/media/icon-decrease.c0e2e79b.svg";